module.exports = __webpack_public_path__ + "static/media/file.2bb26d47.svg";